import {useMemo} from 'react'
import {ImagePicker} from './ImagePicker'
import {DEFAULT_ACCEPTED_IMAGE_FORMATS} from './constants'

interface FileUploadFieldProps {
  acceptedExtensions?: string
  className?: string
  disabled?: boolean
  hasError?: boolean
  maxSize?: number
  updateValue: (file: File | string, fileName?: string, assetId?: string) => void
  maxWidth?: number
  maxHeight?: number
  aspectRatio?: string
  description?: string
  shortDescription?: string
  enableGallery?: boolean
  galleryTag?: string
}

export const FileUploadField = ({
  acceptedExtensions,
  className,
  disabled = false,
  hasError = false,
  maxSize,
  updateValue,
  maxWidth,
  maxHeight,
  aspectRatio,
  description: customDescription,
  shortDescription: customShortDescription,
  enableGallery = false,
  galleryTag,
}: FileUploadFieldProps) => {
  const description = useMemo(() => {
    let value = customDescription ?? 'Drag and drop your file here'

    if (maxWidth && maxHeight) {
      value += ` (${maxWidth}px x ${maxHeight}px)`
    }

    const formats = acceptedExtensions ?? DEFAULT_ACCEPTED_IMAGE_FORMATS
    if (formats) {
      value += ` (Only ${formats})`
    }

    return value.trim()
  }, [customDescription, maxWidth, maxHeight, acceptedExtensions])

  const shortDescription = useMemo(() => {
    let value = customShortDescription ?? ''

    if (aspectRatio) {
      value += ` (Aspect Ratio: ${aspectRatio})`
    } else if (maxWidth && maxHeight) {
      value += ` (Dimensions: ${maxWidth}px x ${maxHeight}px)`
    }

    return value.trim()
  }, [maxWidth, maxHeight, aspectRatio, customShortDescription])

  return (
    <ImagePicker
      accept={acceptedExtensions}
      description={description}
      shortDescription={shortDescription}
      onUpdate={updateValue}
      classNameProp={className}
      maxSize={maxSize}
      disabled={disabled}
      hasError={hasError}
      enableGallery={enableGallery}
      galleryTag={galleryTag}
    />
  )
}
